const MULTIPLAYER_CONTEXT_KEY = '__clMultiplayerTelemetryContext';

const compactObject = object =>
  Object.fromEntries(
    Object.entries(object || {}).filter(([, value]) => value !== undefined)
  );

const getWindowContext = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  if (!window[MULTIPLAYER_CONTEXT_KEY]) {
    window[MULTIPLAYER_CONTEXT_KEY] = {};
  }

  return window[MULTIPLAYER_CONTEXT_KEY];
};

export const getSocketTelemetry = () =>
  typeof window !== 'undefined'
    ? compactObject({
        socket_id: window.socket && window.socket.id,
        socket_connected: window.socket && window.socket.connected
      })
    : {};

export const getRoomTelemetry = room =>
  compactObject({
    room_id: room && room.id,
    match_id: room && (room.matchId || room.match_id),
    room_status: room && room.status,
    map_id: room && room.map,
    turns: room && room.turns,
    ranked: room && room.ranked,
    player1_id:
      room &&
      room.player1 &&
      (room.player1.steamid || room.player1.uid || room.player1.id),
    player2_id:
      room &&
      room.player2 &&
      (room.player2.steamid || room.player2.uid || room.player2.id),
    player_count: room ? [room.player1, room.player2].filter(Boolean).length : 0
  });

export const getMapTelemetry = map =>
  compactObject({
    map_id: map && map.id,
    map_name: map && map.name,
    map_source: map && map.source,
    ugc_level_id: map && map.ugcLevelId,
    published_version_id: map && map.publishedVersionId
  });

export const setMultiplayerTelemetryContext = context => {
  if (typeof window === 'undefined') {
    return {};
  }

  window[MULTIPLAYER_CONTEXT_KEY] = compactObject({
    ...getWindowContext(),
    ...(context || {})
  });

  return window[MULTIPLAYER_CONTEXT_KEY];
};

export const clearMultiplayerTelemetryContext = () => {
  if (typeof window !== 'undefined') {
    window[MULTIPLAYER_CONTEXT_KEY] = {};
  }
};

export const getMultiplayerTelemetryContext = () =>
  compactObject({
    ...getWindowContext(),
    ...getSocketTelemetry()
  });
